import { countries } from './countries';
import { usStates } from './usStates';

/**
 * Attempts to map a `value` to an entry in the `placeList`. If the `value`
 * matches a value or label in the `placeList`, the `placeList` value is
 * returned. If no match is found, `null` is returned.
 */
const normalizeValue = (
  value: string | null | undefined,
  placeList: Array<{ label: string; value: string }>,
): string | null => {
  if (typeof value === 'string') {
    for (const place of placeList) {
      switch (value.toUpperCase()) {
        case place.label.toUpperCase():
        case place.value:
          return place.value;
      }
    }
  }
  return null;
};

/**
 * Map the `value` to a country abbreviation, else return `null`
 */
export const normalizeCountry = (value: string | null | undefined) =>
  normalizeValue(value, countries);

/**
 * Map the `value` to a state abbreviation, else return `null`
 */
export const normalizeState = (value: string | null | undefined) =>
  normalizeValue(value, usStates);
